import axios from 'axios';
import { smallNotification } from '@shared/services/gf.notification.service';

export default {
    sendEditMergeCommitMessage(userAlias, projectAlias, localId, data) {
        return axios
        .post(`/api/project/${userAlias}/${projectAlias}/merge-request/${localId}/merge`,
            data
        )
        .then((res) => {
            return res
        })
        .catch((err) => {
            smallNotification('danger', { title: 'Произошла ошибка!' });
            throw err
        })
    }
}